export function fmtAgo(ms: number | null): string {
  if (ms == null) return "—";
  const s = Math.floor((Date.now() - ms) / 1000);
  if (s < 60) return s + "s ago";
  if (s < 3600) return Math.floor(s / 60) + "m " + (s % 60) + "s ago";
  return (
    Math.floor(s / 3600) + "h " + Math.floor((s % 3600) / 60) + "m ago"
  );
}

export function fmtUptime(sec: number | null | undefined): string {
  if (sec == null) return "—";
  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return `${d}d ${h}h ${m}m`;
}

export function fmtNumber(n: number | null | undefined, digits = 1): string {
  if (n == null || Number.isNaN(n)) return "—";
  return n.toFixed(digits);
}

export type Severity = "ok" | "warn" | "crit" | "unknown";

export function severityForTemp(c: number | null | undefined): Severity {
  if (c == null || Number.isNaN(c)) return "unknown";
  if (c >= 80) return "crit";
  if (c >= 65) return "warn";
  return "ok";
}

export function severityForDisk(pct: number | null | undefined): Severity {
  if (pct == null || Number.isNaN(pct)) return "unknown";
  if (pct >= 90) return "crit";
  if (pct >= 75) return "warn";
  return "ok";
}

export function fmtDurationMs(ms: number): string {
  if (ms <= 0) return "0m";
  const totalMin = Math.floor(ms / 60_000);
  const d = Math.floor(totalMin / 1440);
  const h = Math.floor((totalMin % 1440) / 60);
  const m = totalMin % 60;
  const parts = [];
  if (d) parts.push(`${d}d`);
  if (h) parts.push(`${h}h`);
  if (m || parts.length === 0) parts.push(`${m}m`);
  return parts.join(" ");
}
